import React from 'react'
import Quote from "@system/config/quote";
import Helper from 'src/support/Helper';
import QuoteDetail from '@system/config/quote-detail';
import { useQuoteDetailStore } from 'src/hooks/quote-detail';
import { useState } from 'react';
import { useEffect } from 'react';

const ApprovedQuoteInfoPopup = (props) => {
    const { SetStatus, data } = props;
    const [quoteInfo, setQuoteInfo] = useState('')
    const [{ approved_quote_list }, { }, { }] = useQuoteDetailStore();

    useEffect(() => {
        if (approved_quote_list && data?.quoteNumber && data?.quoteLineNumber) {
            // Find matching quotes
            const quoteDetails = approved_quote_list.filter(x => x.quoteNumber === data.quoteNumber && x.quoteLineNumber === data.quoteLineNumber);

            if (quoteDetails.length > 0) {
                setQuoteInfo(quoteDetails[0]);
            }
        }
    }, [data])
    const redirectQuoteDetail = () => {
        if (quoteInfo) {
            const link = document.createElement('a');
            link.href = QuoteDetail.getQuoteDetailPageRouteURL({
                quote_number: quoteInfo?.quoteNumber,
                quoteProvisionalNumber: quoteInfo?.quoteProvisionalNumber
            });
            link.target = '_blank';
            link.click()
        }
    }

    return (
        <>
            <div className="avnet-modal modal-700">
                <div className="avnet-modal-inner">
                    {/* Modal Header */}
                    <button type="button" className="close py-3" data-dismiss="modal" onClick={(() => SetStatus(false))}>×</button>
                    <div className="modal-header justify-content-center mt-0">
                        <h3 className="modal-title m-auto">{`Quote# ${quoteInfo?.quoteNumber}-${quoteInfo?.quoteLineNumber}`}</h3>
                    </div>

                    {/* Modal body */}
                    <div className="modal-body">
                        <div className="clearfix" />
                        <div className='row'>
                            <div className='col-md-12'>
                                <p className='text-uppercase mb-1'><b>Customer Information</b></p>
                            </div>
                            <div className='col-md-6 mb-3'>
                                <p className='mb-1'><b>Buyer:</b> {quoteInfo?.contactName}</p>
                                <p className='mb-1'><b>Email:</b> {quoteInfo?.contactEmail}</p>
                            </div>

                            <div className='col-md-6'>
                                <p className='mb-1'><b>Requested Date:</b> {Helper.dateFormatFromString(quoteInfo?.quoteRequestedDate)}</p>
                                <p className='mb-1'><b>Expiration Date:</b> {Helper.dateFormatFromString(quoteInfo?.quoteExpiryDate)}</p>
                            </div>
                        </div>

                        <div className='row'>
                            <div className='col-md-12'>
                                <p className='text-uppercase mb-1'><b>Quote Details</b></p>
                            </div>
                            <div className='col-md-6 mb-3'>
                                <p className='mb-1'><b>Manufacturer:</b> {quoteInfo?.manufacturerName}</p>
                                <p className='mb-1'><b>Part Number:</b> {quoteInfo?.partNumber}</p>
                                {quoteInfo?.customerPartNumber && <p className='mb-1'><b>Customer Part Number:</b> {quoteInfo?.customerPartNumber}</p>}
                                <table className="bs5 table table-bordered mt-3 minw280">
                                    <thead>
                                        <tr className='bg-grey2'>
                                            <th>Quantity  </th>
                                            <th>Quoted Price Per Unit</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {quoteInfo?.quotePriceDetails?.length > 0 && quoteInfo?.quotePriceDetails?.map(x => (
                                            <tr>
                                                <td>{x?.quantity}</td>
                                                <td>{Helper.getFormatNumber(x?.quotedPrice, x?.currency, true, 5)}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                            <div className='col-md-6'>

                            </div>
                        </div>

                    </div>
                    {/* Modal footer */}
                    <div className="modal-footer justify-content-center mt-2 d-flex">
                        <div className="modal-footer-actions">
                            <button type="button" className="bs5 btn btn-secondary btn-sm w145" data-dismiss="modal" onClick={() => {
                                SetStatus(false)
                            }}>
                                CLOSE
                            </button>
                            <button type="button" className="bs5 btn btn-primary btn-sm w145" onClick={() => redirectQuoteDetail()}>Go To Quote
                            </button> <br />
                            <a href={Quote.getSubmittedQuoteAbsoluteUrl()} target='_blank' className='text-blue2 mt-2 d-block'> <u>Go to all Quotes </u></a>
                        </div>
                    </div>
                </div>
            </div >
        </>
    )
}

export default ApprovedQuoteInfoPopup
